<script lang="ts">
	let { fill = '#80FFC6', tickColor = '#00523D' } = $props();
</script>

<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
	<circle cx="12" cy="12" r="12" {fill} />
	<path
		d="m9.876 14.568-2.764-2.764-.941.934 3.705 3.706 7.955-7.955-.935-.934-7.02 7.013z"
		fill={tickColor}
	/>
</svg>
